import { render, staticRenderFns } from "./projectPaymentList.vue?vue&type=template&id=21d827a0"
import script from "./projectPaymentList.vue?vue&type=script&lang=js"
export * from "./projectPaymentList.vue?vue&type=script&lang=js"
import style0 from "./projectPaymentList.vue?vue&type=style&index=0&id=21d827a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports